/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import { jsx } from '@atlaskit/css';
import Send from '@atlaskit/icon/core/send';
import Tooltip from '@atlaskit/tooltip';

import Enter from '../../assets/Enter';

import messages from './messages';

type Props = { disabled: boolean; isAIFC?: boolean; onClick?: () => void; tabIndex?: number };

export const SubmitButton = ({ disabled, tabIndex, onClick, isAIFC }: Props) => {
	const { formatMessage } = useIntl();

	const icon = isAIFC ? Send : Enter;

	return (
		<Tooltip content={formatMessage(messages.submitTooltip)} hideTooltipOnClick position="top">
			<IconButton
				label={formatMessage(messages.submitLabel)}
				onClick={onClick}
				testId="submit-icon-button"
				isDisabled={disabled}
				icon={icon}
				appearance="subtle"
				spacing="compact"
				tabIndex={tabIndex}
			/>
		</Tooltip>
	);
};
